<template>
  <InputGroup class="w-fit! h-10">
    <Select
      v-model="selectedTemplate"
      :options="templates"
      showClear
      placeholder="Select a template"
      :option-label
      class="rounded-r-none"
      :class="size"
      @change="emit('selected')"
      pt:label:class="self-center"
    ></Select>

    <IconButton
      v-if="showLoad"
      v-tooltip.top="'Load'"
      icon="file-arrow-up"
      outlined
      small
      :disabled="loadDisabled || selectedTemplate == null"
      @click="emit('load')"
    ></IconButton>
    <IconButton v-if="showSave" v-tooltip.top="'Save'" icon="save" outlined small :disabled="saveDisabled" @click="emit('save')"></IconButton>
    <IconButton
      v-if="showDelete"
      v-tooltip.top="'Delete'"
      icon="trash"
      outlined
      small
      :disabled="deleteDisabled || selectedTemplate == null"
      @click="emit('delete')"
    ></IconButton>
  </InputGroup>
</template>

<script setup lang="ts">
const selectedTemplate = defineModel<Object | undefined>("selectedTemplate", { required: true });

interface Props {
  templates: Object[];
  optionLabel: string;
  showLoad?: boolean;
  showSave?: boolean;
  showDelete?: boolean;
  loadDisabled?: boolean;
  saveDisabled?: boolean;
  deleteDisabled?: boolean;
  size?: string;
}

const props = withDefaults(defineProps<Props>(), {
  showLoad: false,
  showSave: false,
  showDelete: false,
  loadDisabled: false,
  saveDisabled: false,
  deleteDisabled: false,
  size: "w-80",
});

const emit = defineEmits<{
  load: [];
  save: [];
  delete: [];
  selected: [];
}>();
</script>
